import { render, staticRenderFns } from "./goods-status-tag.vue?vue&type=template&id=26468dde&"
import script from "./goods-status-tag.vue?vue&type=script&lang=js&"
export * from "./goods-status-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports